import { combineReducers } from 'redux';

import cssReducer from './css/cssReducer';

const adminReducer = combineReducers({
  css: cssReducer,
});

export default adminReducer;
